import React from 'react'
import DataFund from '../components/DataFund'
import page from '~utils/page'
import { RESOURCES } from '~shared/Nav'
import Head from '~shared/Head'

// eslint-disable-next-line import/no-unused-modules
export default page(DataFund, {
    highlight: RESOURCES,
    streamrClient: true,
    headComponent: (
        <Head
            mediaDescription="Fund for your real-time Web3 data project"
            // eslint-disable-next-line max-len
            description="The Data Fund supports projects that further the vision of a decentralized data economy. Apply now to get funding from a pool of 10 million DATA."
        />
    ),
})
